import calcHeight from './calcHeight'

function main(): void
{
	const slidesCollection = document.querySelectorAll( 
		'main.index>div.second-screen>div.second-slideshow>ul.slides>li' ) as NodeListOf<HTMLElement>;

	if ( slidesCollection.length )
	{
		calcHeight( slidesCollection );
		window.addEventListener( 'resize', () => calcHeight( slidesCollection ) );
	}
}

export {
	main as default,
}
